import React from 'react';
import { DentafixPage } from './pages/DentafixPage';
export function App() {
  return <DentafixPage data-id="element-0" />;
}